import { render, staticRenderFns } from "./DeliveryPriceList.vue?vue&type=template&id=2b6f36de&scoped=true"
import script from "./DeliveryPriceList.vue?vue&type=script&lang=js"
export * from "./DeliveryPriceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6f36de",
  null
  
)

export default component.exports